import { useState, useEffect, useContext } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Sidenav from "examples/Sidenav";
import theme from "assets/theme";
import routes from "routes";
import { useMaterialUIController, setMiniSidenav } from "context";
import brandWhite from "assets/images/wallet-white.png";
import { useAxiosInterceptor } from "./services/interceptor";
import ProtectedRoute from "examples/ProtectedRoute";
import Login from "auth/login";
import { AuthContext } from "context";
import { Helmet } from "react-helmet";

export default function App() {
  const { renderErrorSB, setupAxiosInterceptors } = useAxiosInterceptor();
  const authContext = useContext(AuthContext);
  const [controller, dispatch] = useMaterialUIController();
  const {miniSidenav, layout} = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route && route.type !== "auth") {
        return (
          <Route
            exact
            path={route.route}
            element={
              <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                {route.component}
              </ProtectedRoute>
            }
            key={route.key}
          />
        );
      }
      return null;
    }
  );

  setupAxiosInterceptors();

  return (
    <>
      <Helmet>
        <meta name="keywords" content="Green Wallet," />
        <meta name="description" content="..." />
        <meta itemProp="name" content="Green Wallet" />
        <meta itemProp="description" content="A free full stack app powered by MUI component library, React and Laravel, featuring dozens of handcrafted UI elements" />
        <meta itemProp="image" content="https://s3.amazonaws.com/creativetim_bucket/products/686/original/react-material-dashboard-laravel.jpg?1664783836" />
      </Helmet>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {layout === "dashboard" && (
          <>
            <Sidenav color="info" brand={brandWhite} brandName="Green Wallet" routes={routes} onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave} />
          </>
        )}
        <Routes>
          <Route path="/auth/login" element={<Login />} />
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
        {renderErrorSB}
      </ThemeProvider>
    </>
  );
}
